"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSuperInviter = addSuperInviter;
exports.changeSuperInviterStatus = changeSuperInviterStatus;
exports.deleteSuperInviter = deleteSuperInviter;
exports.editSuperInviter = editSuperInviter;
exports.querySuperInviterDetail = querySuperInviterDetail;
exports.querySuperInviterPage = querySuperInviterPage;
var _request = _interopRequireDefault(require("@/utils/request"));
// 列表
function querySuperInviterPage(data) {
  return (0, _request.default)({
    url: '/portal/system/superInviter/querySuperInviterPage',
    method: 'post',
    data: data
  });
}
// 详情
function querySuperInviterDetail(params) {
  return (0, _request.default)({
    url: '/portal/system/superInviter/querySuperInviterDetail',
    method: 'get',
    params: params
  });
}
// 添加超级管理员
function addSuperInviter(data) {
  return (0, _request.default)({
    url: '/portal/system/superInviter/addSuperInviter',
    method: 'post',
    data: data
  });
}
// 修改超级管理员状态
function changeSuperInviterStatus(data) {
  return (0, _request.default)({
    url: '/portal/system/superInviter/changeSuperInviterStatus',
    method: 'post',
    data: data
  });
}
// 编辑超级管理员
function editSuperInviter(data) {
  return (0, _request.default)({
    url: '/portal/system/superInviter/editSuperInviter',
    method: 'post',
    data: data
  });
}
// 删除超级管理员
function deleteSuperInviter(params) {
  return (0, _request.default)({
    url: '/portal/system/superInviter/deleteSuperInviter',
    method: 'get',
    params: params
  });
}